@if (loading) {
  <app-admin-state-panel
    mode="loading"
    titleKey="COMMON.LOADING"
    descriptionKey="ADMIN.USERS.DETAIL.LOADING"
  ></app-admin-state-panel>
} @else if (hasError || !user) {
  <app-admin-state-panel
    mode="error"
    titleKey="COMMON.ERROR"
    descriptionKey="ADMIN.USERS.DETAIL.ERROR"
    [showRetry]="true"
    (retry)="load()"
  ></app-admin-state-panel>
} @else {
  <app-admin-form-layout
    titleKey="ADMIN.USERS.DETAIL.SECURITY.PASSWORD_TITLE"
    descriptionKey="ADMIN.USERS.DETAIL.SECURITY.PASSWORD_DESCRIPTION"
  >
    <app-form-update-password
      [clearOnUpdate]="true"
      [administration]="true"
      [payload]="{
        id: user.id,
        password: undefined,
        password_confirmation: undefined
      }"
    ></app-form-update-password>
  </app-admin-form-layout>
}
